import React from 'react';
import ReactDOM from 'react-dom';
import App from "./App";
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
ReactDOM.render(<App/>,document.getElementById("root"));